"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const bluebird_1 = __importDefault(require("bluebird"));
const getAssociationsToFollow = (walkMap, record) => {
    const model = record.constructor.getComplexModel();
    const followForThisModel = walkMap[record.constructor.getModelName()] || [];
    return Object.values(model.allowedAssociations).filter((association) => followForThisModel.find(item => item === association.instance));
};
async function associationWalker({ walkMap, actualRecord, callback, associatedRecordGetter, parentRecord = null, scope = actualRecord, optionalArgs, }) {
    const { success, ...args } = await callback.call(scope, actualRecord, parentRecord, optionalArgs);
    ///
    // If the callback function returned false then we already processed this item so
    // we don't want to continue the walk
    //
    if (!success) {
        return;
    }
    //
    // Get all the records associated to this item with the given walk id and call
    // ourselves recursively on them to follow further associations
    //
    const associations = getAssociationsToFollow(walkMap, actualRecord);
    // const associations = getAssociationsToFollow(walkMap, actualRecord);
    await bluebird_1.default.each(associations, async (association) => {
        const records = await associatedRecordGetter(actualRecord, association);
        await bluebird_1.default.each(records, record => associationWalker({
            walkMap, actualRecord: record, callback, associatedRecordGetter, parentRecord: actualRecord, scope, optionalArgs: args,
        }));
    });
}
exports.default = associationWalker;
//# sourceMappingURL=../../src/assiciationWalker.js.map